<template>
    <ds-card>
        <ds-card-header class="card-header">
            <div class="header-text">
                {{ headerText }}
            </div>
        </ds-card-header>

        <ds-card-body class="card-body">
            <div class="body-container">
                <slot name="content" />

                <div class="align-left">
                    <DsOutlineButton
                        v-if="videoAddress"
                        data-qa="watch-video-modal-button"
                        leading-icon="play-circle"
                        target="_blank"
                        @click="openVideo"
                    >
                        Watch a video
                    </DsOutlineButton>

                    <DsModal
                        data-qa="video-modal-player"
                        :is-open="isModalOpen"
                        size="xl"
                        show-close
                        title="Keap Email Health Analytics & Complaints Explained"
                        @close="closeVideo"
                    >
                        <div class="video-container">
                            <script
                                class="video-player"
                                type="application/javascript"
                                charset="ISO-8859-1"
                                src="//fast.wistia.com/assets/external/E-v1.js"
                                async
                            />
                            <div class="wistia_embed wistia_async_8299pif189" style="height:500px;width:100%" />
                        </div>
                    </DsModal>

                    <DsTextButton
                        v-if="linkAddress"
                        trailing-icon="external-link"
                        as="a"
                        :href="linkAddress"
                        target="_blank"
                    >
                        Learn more
                    </DsTextButton>
                </div>
            </div>
        </ds-card-body>
    </ds-card>
</template>

<script>
import amplitude from '../../util/analytics/amplitude';

const BOUNCE_TYPE = 'bounce';
const COMPLAINT_TYPE = 'complaint';

export default {
    props: {
        headerText: {
            type: String,
            required: true,
        },
        linkAddress: String,
        videoAddress: String,
        type: String,
    },

    data() {
        return {
            isModalOpen: false,
        };
    },

    methods: {
        openVideo() {
            this.isModalOpen = true;
        },

        closeVideo() {
            this.isModalOpen = false;
        },

        emitAmplitudeEvent() {
            if (this.type === BOUNCE_TYPE) {
                amplitude.infusionsoft.track('Email Analytics - CTA / Help', {
                    'Event Source': 'Email Analytics Bounce Page',
                    Destination: 'What is link',
                });
            } else if (this.type === COMPLAINT_TYPE) {
                amplitude.infusionsoft.track('Email Analytics - CTA / Help', {
                    'Event Source': 'Email Analytics Complaints Page',
                    Destination: 'What is link',
                });
            }
        },
    },
};

</script>

<style lang="scss" scoped>
.card-header {
    padding: $spacing-200;
    border-bottom: solid px-to-rem(1) $color-ink-200;
}

.header-text {
    font-size: $font-size-lg;
}

.card-body {
    padding-left: $spacing-200;
    padding-right: $spacing-200;
}

.body-container {
    display: flex;
    flex-direction: column;
    align-content: stretch;
}

.video-icon {
    --icon-size: #{px-to-rem(12px)};
}

.learn-more-icon {
    --icon-size: #{px-to-rem(12px)};
}

.align-left {
    text-align: left;
    display: flex;
}

.video-container {
    position: relative;
    padding-bottom: $spacing-200;
    overflow: hidden;
}

.video-player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

</style>
